import { Component } from 'react';

import Select from 'Lib/components/form/Select';
import withSelectField from '../hoc/withSelectField';

class BedsSelect extends Component {
    render() {
        const { field, form, min = 0, max = 10, ...rest } = this.props;
        const options = [];
        let i;

        for (i = min; i <= max; i++) {
            if (i == 0) {
                options.push({ label: 'Studio', value: `${i}` });
            } else if (i == 10) {
                options.push({ label: '10+', value: `${i}` });
            } else {
                options.push({ label: i, value: `${i}` });
            }
        }

        return (
            <Select
                {...rest}
                options={options}
                value={field.value}
                onChange={option => this.props.handleChange(option, form, field)}
                onBlur={() => this.props.handleBlur(form, field)}
            />
        );
    }
}

export default withSelectField(BedsSelect);
